export const formatDateToApi = (value) => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  const pad = (n) => String(n).padStart(2, '0');
  const yyyy = d.getFullYear();
  const mm = pad(d.getMonth() + 1);
  const dd = pad(d.getDate());
  const hh = pad(d.getHours());
  const mi = pad(d.getMinutes());
  const ss = pad(d.getSeconds());
  return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
};

export const toDateOrNull = (value) => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const formatTipoPagamentoToSelect = (value) => {
  if (value === undefined || value === null || value === '') return '';
  const stringValue = String(value);
  const labelMap = { '0': 'Pago', '1': 'A Pagar', '2': 'Outros', '3': 'Outros' };
  return { value: stringValue, label: labelMap[stringValue] || stringValue };
};

export const formatCpfCnpj = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length <= 11) {
    return digits
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
      .slice(0, 14);
  }
  return digits
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .slice(0, 18);
};

export const sanitizeDigits = (value) => {
  const digits = String(value ?? '').replace(/\D/g, '');
  return digits === '' ? null : digits;
};

export const extractSelectValue = (selectValue, { toNumber = false, emptyAsNull = true } = {}) => {
  const raw =
    selectValue && typeof selectValue === 'object' && 'value' in selectValue
      ? selectValue.value
      : selectValue;
  const isEmpty = raw === undefined || raw === null || raw === '';
  if (isEmpty) return emptyAsNull ? null : '';
  if (toNumber) {
    const n = Number(raw);
    return Number.isNaN(n) ? null : n;
  }
  return raw;
};

export const parseCurrencyToNumber = (value) => {
  if (value === '' || value === null || value === undefined) return 0;
  if (typeof value === 'number') return Number.isNaN(value) ? 0 : value;
  const normalized = String(value)
    .replace(/[^\d,.-]/g, '')
    .replace(/\./g, '')
    .replace(',', '.');
  const n = Number(normalized);
  return Number.isNaN(n) ? 0 : n;
};

export const formatCurrencyBr = (value, { withSymbol = false } = {}) => {
  if (value === undefined || value === null || value === '') return '';
  const n = Number(value);
  if (Number.isNaN(n)) return '';
  const formatted = n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return withSymbol ? `R$ ${formatted}` : formatted;
};

export const formatStatusCtnrToSelect = (value) => {
  if (value === undefined || value === null || value === '') return '';
  const stringValue = String(value);
  const labelMap = { '1': 'OK', '2': 'PENDENTE' };
  return { value: stringValue, label: labelMap[stringValue] || stringValue };
};

export const formatSituacaoDepotToSelect = (value) => {
  if (value === undefined || value === null || value === '') return '';
  const stringValue = String(value);
  const labelMap = { '1': 'OK', '2': 'PENDENTE' };
  return { value: stringValue, label: labelMap[stringValue] || stringValue };
};

export const formatTipoTomadorToSelect = (value) => {
  if (value === undefined || value === null || value === '') return '';
  const stringValue = String(value);
  const labelMap = {
    '0': 'Remetente',
    '1': 'Expedidor',
    '2': 'Recebedor',
    '3': 'Destinatário',
    '4': 'Outros',
  };
  return { value: stringValue, label: labelMap[stringValue] || stringValue };
};
